import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import HotelBiGridOptionsBase from './hotel-bi-grid-options-base';

const { bingadsGridColumn } = globalContext.require('component/bingads-grid/shared/column');
const i18n = globalContext.require('@bingads-webui/i18n-amd-loader!campaignui/feature/hotel-center');


export default class LengthOfStayGridOptions extends HotelBiGridOptionsBase {
  constructor({
    view, gridName, dateFilterContainer, p$daterange, filterService, preferenceService,
  }) {
    const columnsPrev = ['LengthOfStay'];

    super({
      view,
      gridName,
      dateFilterContainer,
      columnsPrev,
      p$daterange,
      filterService,
      preferenceService,
    });

    this.columns.unshift(bingadsGridColumn({
      name: 'LengthOfStay',
      title: i18n.getString('HotelCenter_Overview_Grid_Switcher_Hotel_Length_Of_Stay_Label'),
      sortable: true,
      filterable: true,
      type: 'Number',
    }));

    this.plugins.columnChooser.categories[0].options.unshift({
      key: 'LengthOfStay',
      name: this.i18n.getString('HotelCenter_Overview_Grid_Switcher_Hotel_Length_Of_Stay_Label'),
      selectOption: 'locked',
    });
  }
}
